import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./styles";
import AddBooking from "./createBooking";
import ListBooking from "./listBooking";
import Header from "../../partials/header";
class Booking extends React.Component {
  constructor(props) {
    super(props);
    let now = new Date();
    this.to = new Date().setHours(23, 59, 59, 999);
    this.from = new Date(
      new Date().setMonth(new Date().getMonth() - 1)
    ).setHours(0, 0, 0, 0);
    this.state = {
      isAddBooking: false,
      // from: new Date(),
      // to: new Date(),
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.addNewBooking = this.addNewBooking.bind(this);
    this.handleFilterDate = this.handleFilterDate.bind(this);
  }
  componentDidMount = async () => {
    // await this.props.serviceBranch.getListBranchs();
  };
  handleSearch(event) {
    this.ListBooking.handleSearch(event.target.value);
  }
  addNewBooking() {
    this.setState({ isAddBooking: !this.state.isAddBooking });
  }
  afterCreateBooking = (check) => {
    this.setState({ isAddBooking: false }, function () {});
  };
  handleFilterDate(from, to) {
    this.ListBooking.handleChangeDate(from, to);
  }
  render() {
    const { t } = this.props;
    return (
      <div>
        {!this.state.isAddBooking ? (
          <Header
            session={t("sidebar_manage")}
            title={t("booking_booking")}
            showFilterDate={true}
            handleFilterDate={this.handleFilterDate}
            titleToolipIconDateRange={t("booking_filter_by_time")}
            from={this.from} // mặc định là từ 1 tháng trước ngày hiện tại
            to={this.to}
          />
        ) : (
          <Header
            session={t("booking_booking")}
            title={t("booking_create_create_booking")}
            backIcon={true}
            actionBack={() => this.addNewBooking()}
          />
        )}
        {this.state.isAddBooking ? (
          <AddBooking
            addNewBooking={this.addNewBooking}
            afterCreateBooking={this.afterCreateBooking}
          />
        ) : (
          <ListBooking
            addNewBooking={this.addNewBooking}
            onRef={(id) => (this.ListBooking = id)}
            from={this.from} // mặc định là từ 1 tháng trước ngày hiện tại
            to={this.to}
          />
        )}
      </div>
    );
  }
}

Booking.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listBookings: state.booking.listBookings,
});

const mapDispatch = (dispatch) => ({
  bookingDispatch: dispatch.booking,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Booking)));
